import { render, staticRenderFns } from "./EditServiceCenterPage.vue?vue&type=template&id=8bf7bd78"
import script from "./EditServiceCenterPage.vue?vue&type=script&lang=js"
export * from "./EditServiceCenterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports